export const state = () => ({
    termList: []
});
export const mutations = {
    mutateTermList(state, payload) {
        state.termList = payload;
    }
};